module.exports = __webpack_public_path__ + "img/gdsgzsgzgzc_img.76643ac8.png";